import {
  CalendarEventWriteResult,
  RespondToCalendarEventInput,
} from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type RespondToExternalCalendarEventOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: RespondToCalendarEventInput;
};

export const respondToExternalCalendarEvent = async <TFunctions>(
  options: RespondToExternalCalendarEventOptions<TFunctions>,
): Promise<CalendarEventWriteResult> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    RespondToCalendarEventInput,
    CalendarEventWriteResult
  >(functions, 'externalCalendars-respondToEvent');

  const { data } = await callable(payload);

  return data;
};
